module.exports = __webpack_public_path__ + "static/img/text4.9c717b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/text4.png
// module id = wwzZ
// module chunks = 1